module.exports = __webpack_public_path__ + "bc1831fcb04cd643af7e880cd21e1a78.jpg";